export const CURRENCY = {
  USD: 'usd'
};
